/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Whether an MCP server address could be read at all.
 */
export enum McpServerLookupResult {
    OK = 'ok',
    FAILED = 'failed',
}
